import { environmment as defaultEnvironment } from './environment.default';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  ...defaultEnvironment,
  production: false,
  BASE_URL: 'http://localhost:4200',
  // REST_API_URL:'http://localhost/intandemlyhr_api',//'https://hrapi.intandemly.com',
  REST_API_URL: 'https://hrapi.intandemly.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
